import { render, staticRenderFns } from "./mob-basic.vue?vue&type=template&id=319cbcfe&scoped=true"
import script from "./mob-basic.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-basic.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319cbcfe",
  null
  
)

export default component.exports